import { createSelector } from 'reselect';
import { AuthTypes } from 'enums';
import { bypassTokenSelector } from 'common/selectors/appSelector';
import pageSelector from 'common/selectors/pageSelector';
import selectedContentSelector from 'common/selectors/selectedContentSelector';
import selectedStreamSelector from 'common/selectors/selectedStreamSelector';
import playingStreamSelector from 'common/selectors/playingStreamSelector';
import playerSelector from 'common/selectors/playerSelector';
import { oneIdTokenSelector } from 'common/selectors/oneIdSelector';
import { userAuthSelector, ipInfoSelector, adobePassInfoSelector } from 'common/selectors/authenticationSelectors';
import { authStateKnown, streamHasAuthType, canPlayContent, shallowCheckAuthentication } from 'lib/auth';
import { isEmpty } from 'lib/util';

/**
 * This selector only returns content if all the conditions needed for playback are met
 */
export default createSelector(
    pageSelector,
    playerSelector,
    selectedContentSelector,
    playingStreamSelector,
    selectedStreamSelector,
    userAuthSelector,
    ipInfoSelector,
    adobePassInfoSelector,
    bypassTokenSelector,
    oneIdTokenSelector,
    (
        page,
        player,
        selectedContent,
        playingStream,
        selectedStream,
        userAuth,
        ipInfo,
        adobePassInfo,
        bypassToken,
        oneIdToken
    ) => {
        const isVod = selectedContent && selectedContent.type === 'vod';

        if (
            page.scored &&
            player.ready === true &&
            (authStateKnown(userAuth) || isVod || !userAuth.length) &&
            !isEmpty(selectedStream) &&
            selectedContent.reEmbed !== false &&
            player.autoEmbedTimerComplete === true &&
            (
                // This must be for when the linear content has changed the program
                (selectedStream.content && selectedContent.id !== selectedStream.content.id) ||
                selectedStream.id !== playingStream.id
            )
        ) {
            if (
                canPlayContent(selectedContent, userAuth, false) &&
                shallowCheckAuthentication(selectedStream, userAuth, false)
            ) {
                if (!selectedStream.authTypes || selectedStream.authTypes.length === 0 ||
                    selectedStream.source.id === 'SHORTSTOPLIVE' || bypassToken) {
                    return { ...selectedStream };
                } else if (streamHasAuthType(selectedStream, AuthTypes.ISP) && userAuth.indexOf(AuthTypes.ISP) !== -1) {
                    return { ...selectedStream, ipInfo };
                } else if (streamHasAuthType(selectedStream, AuthTypes.MVPD) && adobePassInfo) {
                    return { ...selectedStream, adobePassInfo };
                } else if (streamHasAuthType(selectedStream, AuthTypes.OPEN)) {
                    return { ...selectedStream };
                } else if (streamHasAuthType(selectedStream, AuthTypes.BAM) && oneIdToken) {
                    return { ...selectedStream };
                }
            }
        }
        return {};
    }
);



// WEBPACK FOOTER //
// ./app/common/selectors/onDeckContentSelector.js